import React from 'react'
import { styled } from '@mui/material/styles'
import zIndex from 'src/common/theme/zIndex'
import { Padding } from '@mui/icons-material'

const FlexFieldContainer = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '24px',
  position: 'relative',
  ['[role="tooltip"]']: {
    visibility: 'hidden',
    position: 'absolute',
    top: '1rem',
    left: '1rem',
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    zIndex: '100',
    fontSize: '0.75rem',
    padding: '0.5rem',
    borderRadius: '4px',
  },
  '&:hover': {
    '[role="tooltip"]': {
      visibility: 'visible'
    }
  }
}))

const CustomLabel = styled('label')(({ theme, primary }) => ({
  color: primary ? theme.palette.primary.dark : theme.palette.secondary.main,
  fontSize: '0.75rem',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '16px',
  textAlign: 'left',
}))

const ElementWrapper = styled('div')(() => ({
  '& .MuiTextField-root': {
    width: '100%',
  },
}))

interface SidebarFieldProps {
  /* The id of the input element */
  id: string
  /* The label of the input element */
  label?: string
  /** primary determines which color from theme palette to use */
  primary?: boolean
  /* The HTML element that is related to the label */
  children: React.ReactNode
  tooltip?: string
}

export const SidebarField = ({
  id,
  label,
  primary,
  children,
  tooltip = null
}: SidebarFieldProps) => {
  return (
    <FlexFieldContainer>
      <CustomLabel htmlFor={id} primary={primary}>
        {label}
      </CustomLabel>
      {tooltip && <div role="tooltip">{tooltip}</div>}
      <ElementWrapper>{children}</ElementWrapper>
    </FlexFieldContainer>
  )
}
